module.exports = __webpack_public_path__ + "img/home-pos-image.92f6872e.png";